import { Button, Row, Select, Table } from 'antd';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { Months } from '../../models';
import { ConsultaMensualTable } from '../../models/ConsultaMensualTable';
import { ConsultaStore } from '../../stores/consultaStore';

const PageHeader = styled.h1`
    margin-top: 25px;
    font-size: 24px;
`;
const HeaderContainer = styled.div`
    text-align: center;
    margin-top: 25px;
`;
const ConsultasWrapper = styled.div`
    margin: 0 auto;
    padding: 10px 0px 50px;
    max-width: 1600px;
`;

interface ConsultaMensualProps extends RouteComponentProps {
    consultaStore?: ConsultaStore;
}

@inject('consultaStore')
@observer
class ConsultaMensualInner extends React.Component<ConsultaMensualProps, {}> {
    async componentDidMount() {
        const { consultaStore } = this.props;
        consultaStore!.inicializarFiltros();
        consultaStore!.filtros!.Mes = 1;
        const fecha = new Date();
        consultaStore!.filtros!.Ejercicio = fecha.getFullYear();
        consultaStore!.filtros!.Municipio = 0;
        await consultaStore!.getMunicipios();
        await consultaStore!.getConsultaMensual();
    }
    renderEjercicio = () => {
        return (
            <Select
                style={{ width: '100%' }}
                placeholder="Ejercicio"
                optionFilterProp="children"
                onChange={this.handleEjercicio}
                defaultValue={2019}
            >
                <Select.Option key={2019}>2019</Select.Option>
            </Select>
        );
    };
    handleEjercicio(value: number) {
        const { consultaStore } = this.props;
        consultaStore!.filtros!.Ejercicio = value;
        consultaStore!.getConsultaMensual();
    }

    renderMes = () => {
        return (
            <Select
                style={{ width: '100%' }}
                placeholder="Mes"
                optionFilterProp="children"
                onChange={this.handleMes}
                defaultValue={'Enero'}
            >
                {Months.map((mes, index) => (
                    <Select.Option key={index + 1}>{mes}</Select.Option>
                ))}
            </Select>
        );
    };

    handleMes = (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.filtros!.Mes = value;
        consultaStore!.getConsultaMensual();
    };

    renderMunicipio = () => {
        return (
            <Select
                showSearch={true}
                style={{ width: '100%' }}
                placeholder="Municipio"
                optionFilterProp="children"
                onChange={this.handleMunicipio}
            >
                <Select.Option key={'0'}>Todos</Select.Option>
                {this.props.consultaStore!.listaMunicipios.map(municipio => (
                    <Select.Option key={municipio.id}>{municipio.nombre}</Select.Option>
                ))}
            </Select>
        );
    };
    handleMunicipio = (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.filtros!.Municipio = value;
        consultaStore!.getConsultaMensual();
    };

    clickExportar = async () => {
        const { consultaStore } = this.props;
        const response = await consultaStore!.getReporteMensualExcel();
        const type = 'application/vnd.ms-excel'; 
        const blob = new Blob([response], { type }); 

        const reader = new FileReader();
        const fileDownload = require('react-file-download');
        fileDownload(blob, 'CAPTURAS_HECHAS_'+consultaStore!.mesString(consultaStore!.filtros!.Mes).toUpperCase()+'_'+consultaStore!.filtros.Ejercicio+'.xlsx');
    };

    render() {
        const { consultaStore } = this.props;
        const stylePrimary = {
            backgroundColor:'#a8123e', borderColor:'#a8123e'
        };
        const styleVeda = {
            backgroundColor:'#3c3c3b', borderColor:'#3c3c3b'
        };
          
        return (
            <>
                <ConsultasWrapper>
                    <Row>
                        <Table 
                            columns={ConsultaMensualTable}
                            bordered={true}
                            dataSource={consultaStore!.registrosMensual}
                            pagination={false}
                            rowKey={'id'}
                        />
                    </Row>
                    <br/>
                    <Row style={{textAlign: 'right'}} >
                        <Button icon="download" type="primary" onClick={this.clickExportar} style={styleVeda} >
                            Descarga Consulta Mensual
                        </Button>
                    </Row>
                </ConsultasWrapper>
            </>
        );
    }
}

export const ConsultaMensual = withRouter(ConsultaMensualInner);
